import { snapshotExists } from '../utils/snapshot.util';

export default class NotificationService {
  constructor(firebase) {
    this.firebase = firebase;
  }

  async getNotifications(uid, limit) {
    const querySnapshot = await this.firebase.firestore()
      .collection('users')
      .doc(uid)
      .collection('notifications')
      .orderBy('dateAdded', 'desc')
      .limit(limit)
      .get();

    const notifications = [];

    querySnapshot.forEach((doc) => {
      notifications.push({
        ...doc.data(),
        id: doc.id,
      });
    });

    return notifications;
  }

  async deleteNotification(uid, id) {
    return this.firebase.firestore()
      .collection('users')
      .doc(uid)
      .collection('notifications')
      .doc(id)
      .delete();
  }

  async deleteAllNotifications(uid) {
    const batch = this.firebase.firestore().batch();

    const notificationDocs = await this.firebase.firestore()
      .collection('users')
      .doc(uid)
      .collection('notifications')
      .limit(500)
      .get();

    notificationDocs.forEach((notificationDoc) => {
      if (snapshotExists(notificationDoc)) {
        batch.delete(this.firebase.firestore()
          .collection('users')
          .doc(uid)
          .collection('notifications')
          .doc(notificationDoc.id));

      }
    });

    await batch.commit();
  }

  async markNotificationAsRead(uid, id) {
    return this.firebase.firestore()
      .collection('users')
      .doc(uid)
      .collection('notifications')
      .doc(id)
      .update({ read: true });
  }

  async markAllNotificationsAsRead(uid) {
    const batch = this.firebase.firestore().batch();

    const notificationDocs = await this.firebase.firestore()
      .collection('users')
      .doc(uid)
      .collection('notifications')
      .where('read', '==', false)
      .get();

    notificationDocs.forEach((notificationDoc) => {
      if (snapshotExists(notificationDoc)) {
        batch.update(this.firebase.firestore().collection('users').doc(uid).collection('notifications').doc(notificationDoc.id), {
          read: true,
        });
      }
    });

    return batch.commit();
  }

  async setUserReadNotifications(uid) {
    return this.firebase.firestore()
      .collection('users')
      .doc(uid)
      .update({ hasUnreadNotifications: false });
  }
}
